"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagDM = function FlagDM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "106.93",
    width: "409.6",
    height: "18.83",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "125.76",
    width: "409.6",
    height: "18.83",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "144.59",
    width: "409.6",
    height: "18.83",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "177.55",
    y: "1",
    width: "18.83",
    height: "268.36",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "196.38",
    y: "1",
    width: "18.83",
    height: "268.36",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "215.21",
    y: "1",
    width: "18.83",
    height: "268.36",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M82.43,12.18A70.63,70.63,0,1,1,11.8-58.45,70.63,70.63,0,0,1,82.43,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.74,24.33s-.83,5.77,4.78,14.35H21.41L18.93,28.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5-14.32s-17.81,29.14,8.35,46.51L16.07,15.7,17.83-5.64l-2.75-9.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#a561cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5-14.32A46,46,0,0,0,1.25-5.84C3.54-3.44,9.8-.47,17.51-1.77l.32-3.87-2.75-9.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.56-18.5s.22-5.83,5.94-5.83c7.14,0,13,1.65,22.21,20.78,0,0-8.22,8.07-13.42-3.08a29.4,29.4,0,0,1-2.09-7.25s-6.38,2.2-10.77-.33Zm0,0",
    transform: "translate(194 123)",
    fill: "#a561cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.42-15.75,3.1-19.27s-7.37-1.21-4.29,7.7A1.79,1.79,0,0,1,.9-13.11c1.87.22,3.85-1.21,3.52-2.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.73,17.68S9,23.75,13.32,38c2.31,7.59,11.55,15.91,11.55,15.91S31.71,36,29.49,29.11C28.18,25,16.73,17.68,16.73,17.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.47,40.66s-20-19.08-21.34-34.09S17.47-6.06,19-5.09c3.74,2.31,13.2,12,12.43,45.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29,45H-4.15A1.25,1.25,0,0,1-5.4,43.78V41.32a1.25,1.25,0,0,1,1.25-1.24H29a1.25,1.25,0,0,1,1.25,1.24v2.46A1.25,1.25,0,0,1,29,45Zm0,0",
    transform: "translate(194 123)",
    fill: "#b34900"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.91,40.33c-1.15.47-3.46,1.07-2.89,3.13.45,1.58,3.47,1.4,2.89,3.22-.39,1.22-6.53,1.34-8.91,1-1.45-.22-4.61-1.08-4.18-4.7s1.77-4.19,3.41-4.84,8.8-.5,9.85.38a1.05,1.05,0,0,1-.17,1.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.45-50.91l1.61,4.82,5.08,0a.68.68,0,0,1,.4,1.23l-4.09,3L17-36.95a.68.68,0,0,1-1.05.76l-4.13-3-4.13,3a.68.68,0,0,1-1-.76L8.15-41.8l-4.09-3A.68.68,0,0,1,4.46-46l5.08,0,1.61-4.82a.69.69,0,0,1,1.3,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.45,61.77l1.61,4.82,5.08,0a.69.69,0,0,1,.4,1.24l-4.09,3L17,75.73a.68.68,0,0,1-1.05.76L11.8,73.54,7.67,76.49a.68.68,0,0,1-1-.76l1.53-4.84-4.09-3a.69.69,0,0,1,.4-1.24l5.08,0,1.61-4.82a.69.69,0,0,1,1.3,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.45-50.91l1.61,4.82,5.08,0a.68.68,0,0,1,.4,1.23l-4.09,3L17-36.95a.68.68,0,0,1-1.05.76l-4.13-3-4.13,3a.68.68,0,0,1-1-.76L8.15-41.8l-4.09-3A.68.68,0,0,1,4.46-46l5.08,0,1.61-4.82a.69.69,0,0,1,1.3,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.45,61.77l1.61,4.82,5.08,0a.69.69,0,0,1,.4,1.24l-4.09,3L17,75.73a.68.68,0,0,1-1.05.76L11.8,73.54,7.67,76.49a.68.68,0,0,1-1-.76l1.53-4.84-4.09-3a.69.69,0,0,1,.4-1.24l5.08,0,1.61-4.82a.69.69,0,0,1,1.3,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.81-39.35l1.4,4.89-4.16,2.91a.68.68,0,0,0,.37,1.24l5.08.17,1.48,4.86a.69.69,0,0,0,1.3,0L-19.61-30l5.08.09a.69.69,0,0,0,.44-1.23l-4-3.12,1.65-4.8a.68.68,0,0,0-1-.79L-21.69-37l-4-3.06a.68.68,0,0,0-1.07.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.07,53.48l1.4,4.88-4.16,2.91a.69.69,0,0,0,.37,1.25l5.08.17,1.48,4.86a.69.69,0,0,0,1.3,0l1.73-4.78,5.08.09a.68.68,0,0,0,.43-1.22l-4-3.12,1.66-4.8a.69.69,0,0,0-1-.8L42.19,55.8l-4-3.06a.69.69,0,0,0-1.07.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-50.69-7l4,3.06L-48.22.89a.69.69,0,0,0,1,.77L-43-1.25l4.1,3A.69.69,0,0,0-37.85,1l-1.48-4.86,4.11-3a.68.68,0,0,0-.39-1.24l-5.07-.09L-42.24-13a.69.69,0,0,0-1.3,0l-1.66,4.8h-5.08A.68.68,0,0,0-50.69-7Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M56.12,28.89,60.18,32,58.6,36.78a.68.68,0,0,0,1,.77l4.16-2.91,4.11,3a.68.68,0,0,0,1-.76L67.48,32l4.12-3a.69.69,0,0,0-.39-1.24l-5.08-.09-1.56-4.84a.69.69,0,0,0-1.3,0l-1.66,4.8H56.53a.69.69,0,0,0-.41,1.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.73-39.35l-1.41,4.89,4.16,2.91a.68.68,0,0,1-.37,1.24L45-30.14l-1.49,4.86a.69.69,0,0,1-1.3,0L40.52-30l-5.07.09A.69.69,0,0,1,35-31.16l4-3.12-1.66-4.8a.69.69,0,0,1,1-.79L42.6-37l4.06-3.06a.68.68,0,0,1,1.07.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-16.15,53.48l-1.41,4.88,4.16,2.91a.69.69,0,0,1-.37,1.25l-5.07.17-1.48,4.86a.69.69,0,0,1-1.3,0l-1.73-4.78-5.08.09a.68.68,0,0,1-.44-1.22l4-3.12-1.66-4.8a.69.69,0,0,1,1-.8l4.2,2.85,4.06-3.06a.69.69,0,0,1,1.07.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M71.61-7,67.55-3.94,69.13.89a.68.68,0,0,1-1,.77L63.93-1.25l-4.11,3a.68.68,0,0,1-1-.76l1.48-4.86-4.12-3a.69.69,0,0,1,.39-1.24l5.08-.09L63.16-13a.69.69,0,0,1,1.3,0l1.65,4.8H71.2A.69.69,0,0,1,71.61-7Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-35.2,28.89-39.26,32l1.58,4.83a.68.68,0,0,1-1,.77l-4.17-2.91-4.1,3A.69.69,0,0,1-48,36.88L-46.57,32l-4.11-3a.68.68,0,0,1,.39-1.24l5.08-.09,1.56-4.84a.68.68,0,0,1,1.29,0l1.66,4.8h5.08a.69.69,0,0,1,.42,1.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagDM;
exports["default"] = _default;